import image1 from "../assets/t-image1.png";
import image2 from "../assets/t-image2.jpg";
import image3 from "../assets/t-image3.jpg";

export const testimonialsData = [
  {
    image: image1,
    review:
      "I made the right choice by choosing the GYM and by choosing the right plan and program I already achieved my ideal body!",
    name: 'Reeza Hendricks',
    status : 'CUSTOMER'
  },
  {
    image: image2,
    review: 'Good staff, great personal trainers! Here you got all the stuff you need for a perfect workout. Just an awesome gym! :) ',
    name: 'Tim David',
    status: 'CUSTOMER'
  },
  {
    image : image3,
    review:'Really great and professional gym! With good machines and very kind and helpful staff!',
    name: 'Steve Smith',
    status: "CUSTOMER"
  }
];
